import type React from "react"
import { useContext, useEffect, useState } from "react"
import { Form, Row, Col, Input } from "antd"
import DataGrid from "components/theme_components/DataGrid"
import { getOfferListByCriteria, type GetOfferListByCriteriaParams } from "services/pricing"
import { useQuery } from "react-query"
import FormInput from "components/FormInput"
import ResetButtonAction from "components/theme_components/ResetButtonAction"
import ButtonLink from "components/theme_components/ButtonLink"
import { AuthContext } from "components/Auth/Auth"
import ProductConversionRuleListSelect from "components/ProductConversionRuleListSelect"
import { getConversionRuleListByCriteria } from "services/parametersService"

type AutomaticConversionModalProps = {
  setVisible: (visible: boolean) => void
  dataConv: any
  prcode: string
  offertarget: string
  handleConfirm: () => void
  currentSelectedOffers?: any[]
  onSelectOffer?: (offerlist: any[]) => void
}

const AutomaticConversionModal: React.FC<AutomaticConversionModalProps> = ({
  setVisible,
  dataConv,
  prcode,
  handleConfirm,
  currentSelectedOffers = [],
  onSelectOffer,
}) => {
  const mgid = localStorage.getItem("mgid")
  const { data: rulelist,isLoading } = useQuery(
      ['getConversionRuleListByCriteria', { sourcePrcode:  prcode,
                  targetPrcode: "",
                  isAuthorized: undefined,
                  page: undefined,
                  size: undefined,
                  sortBy: '',
                  sortDirection: '',}],
      () => getConversionRuleListByCriteria({ sourcePrcode:  prcode,
                  targetPrcode: "",
                  isAuthorized: undefined,
                  page: undefined,
                  size: undefined,
                  sortBy: '',
                  sortDirection: '',}).then((res) => res.list || []),
    );
const targetPrcodesString = rulelist?.map(rule => rule.targetPrcode).join(',') || '';
  useEffect(() => {
  if (targetPrcodesString) {
    setSearchParams((prev) => ({
      ...prev,
      prcode: targetPrcodesString,
    }))
  }
}, [targetPrcodesString])
  const initialSearchParams: GetOfferListByCriteriaParams = {
    mgid: mgid ? Number.parseInt(mgid, 10) : 0,
    //prcode: targetPrcodesString??"",
      prcode: "", 
    offerlabel: "",
    status: "ACTIVE",
    finamount: "" as any,
    duration: "" as any,
  }

  const [searchParams, setSearchParams] = useState<GetOfferListByCriteriaParams>({
    ...initialSearchParams,
  })

  // Fix: Use searchParams instead of initialSearchParams for the query
  const {
    data: offerlist,
    refetch,
    isFetching,
  } = useQuery(
    ["getOfferListByCriteria", searchParams], // Use searchParams as dependency
    () => getOfferListByCriteria(searchParams).then((res) => res.list || []), // Use searchParams in query
    {
      refetchOnMount: false,
      enabled: true,
      // Add keepPreviousData to prevent loading state on search
      keepPreviousData: true,
    },
  )

  const [form] = Form.useForm()
  const { isInspect } = useContext(AuthContext)

  // Initialize with current selections
  const [selectedOfferList, setSelectedOfferList] = useState<any[]>(currentSelectedOffers)
  const [selectedKeys, setSelectedKeys] = useState<any[]>(currentSelectedOffers.map((offer) => offer.offerid))

  // Update selected state when currentSelectedOffers changes
  useEffect(() => {
    if (currentSelectedOffers?.length) {
      setSelectedOfferList(currentSelectedOffers)
      setSelectedKeys(currentSelectedOffers.map((offer) => offer.offerid))
    }
  }, [currentSelectedOffers])

  const columns = [
    {
      dataIndex: "prcode",
      key: "prcode",
      width: "80px",
    },
    {
      dataIndex: "offercode",
      key: "offercode",
    },
    {
      dataIndex: "offerlabel",
      key: "offerlabel",
    },
  ]
useEffect(() => {
}, [offerlist])

  // Row selection for multi-page selection
 const rowSelection = {
  onChange: (newSelectedRowKeys: React.Key[], selectedRows: any[]) => {
    const selectedMap = new Map(selectedOfferList.map((offer) => [offer.offerid, offer]))

    selectedRows.forEach((row) => {
      if (row && row.offerid !== undefined) {
        selectedMap.set(row.offerid, row)
      }
    })

    offerlist?.forEach((offer) => {
      if (offer && offer.offerid !== undefined && !newSelectedRowKeys.includes(offer.offerid)) {
        selectedMap.delete(offer.offerid)
      }
    })

    const updatedSelectedOffers = Array.from(selectedMap.values())
    const updatedSelectedKeys = updatedSelectedOffers
      .filter((offer) => offer && offer.offerid !== undefined)
      .map((offer) => offer.offerid)

    setSelectedOfferList(updatedSelectedOffers)
    setSelectedKeys(updatedSelectedKeys)
  },
  selectedRowKeys: selectedKeys,
  preserveSelectedRowKeys: true,
}

  // Fix: handleValuesChange now properly triggers search
  const handleValuesChange = (changedValues: any) => {
    setSearchParams({ ...searchParams, ...changedValues })
  }

  const handleReset = () => {
    form.resetFields()

    const resetParams = {
      mgid: mgid ? Number.parseInt(mgid, 10) : 0,
      prcode: "",
      offerid: "" as any,
      offerlabel: "",
      status: "",
      finamount: "" as any,
      duration: "" as any,
    }

    setSearchParams(resetParams)
    // Don't reset selected offers on search reset
  }

  const handleConfirmSelection = () => {
    if (!isInspect && onSelectOffer) {
      onSelectOffer(selectedOfferList)
    }
    setVisible(false)
  }

  const handleCancel = () => {
    // Reset to original selections on cancel
    setSelectedOfferList(currentSelectedOffers)
    setSelectedKeys(currentSelectedOffers.map((offer) => offer.offerid))
    setVisible(false)
  }

  useEffect(() => {
    if (!offerlist) {
      form.resetFields()
    } else {
      form.setFieldsValue({
        ...offerlist,
      })
    }
  }, [offerlist, form])

  return (
    <Form form={form} layout="vertical" className="no-border-radius ut-wizard-form" onValuesChange={handleValuesChange}>
      <Row gutter={16}>
        <Col span={6}>
          <FormInput name="prcode" nolabel>
           {/* <ProductInput /> */}
            <ProductConversionRuleListSelect
                params={{
                  sourcePrcode:  prcode,
                  targetPrcode: "",
                  isAuthorized: true,
                  page: undefined,
                  size: undefined,
                  sortBy: '',
                  sortDirection: '',
                }}
                multiMode
                onSelected={(value:any) => {
                 // setprcode(value.targetPrcode);
                  form.setFieldsValue({ procdetarget: value.targetPrcode });
                }}
                onChange={(value:any) => { form.setFieldsValue({ offerIdTarget: "" });}}
              />
          </FormInput>
        </Col>
        <Col span={6}>
          <FormInput name="offerid" nolabel>
            <Input name="offerid" className="ut-input-search ut-input-search-TP-parent" />
          </FormInput>
        </Col>
        <Col span={6}>
          <FormInput name="offerlabel" nolabel>
            <Input name="offerlabel" className="ut-input-search ut-input-search-TP-parent" />
          </FormInput>
        </Col>
        <Col span={6} className="d-flex justify-center">
          <ResetButtonAction comcode="Reset" className="ant-btn-outline-primary" type="default" onClick={handleReset} />
        </Col>
      </Row>
      <DataGrid
        columns={columns}
        dataSource={offerlist}
        rowSelection={{ type: "checkbox", ...rowSelection }}
        rowKey={(record) => record.offerid}
        isLoading={!targetPrcodesString}
      />
      <Row justify="end" style={{ marginTop: 10 }}>
        <ButtonLink htmlType="button" type="text" comcode="cancel" iconPosition="end" onClick={handleCancel} />
        <ButtonLink
          htmlType="button"
          type="primary"
          onClick={handleConfirmSelection}
          comcode="add"
          iconPosition="end"
          className="ml-4"
        />
      </Row>
    </Form>
  )
}

export default AutomaticConversionModal
